import Page from 'shared/types/Page'
import getPages from 'utils/getPages'

const getPageByPath = (path: string | undefined, pages?: Page[]): Page | null => {

    let curPage

    if (typeof pages != 'undefined') {
        curPage = pages.find(item => {
            return item.path === path
        })
        return curPage ?? null
    }
    else {
        const pages = getPages()
        curPage = pages.find(item => {
            return item.path === path
        })
        return curPage ?? null
    }

}

export default getPageByPath